/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { annonceRelanceResponseSchema } from "../annonceRelanceResponseSchema.ts";
import { z } from "zod";

export const publishDiffusionForProductPathParamsSchema = z.object({
      "annonceId": z.coerce.number().int().describe("ID unique de l'annonce à publier."),
  "codeProduit": z.string().describe("Code du produit pour lequel publier la diffusion.")
      })

export const publishDiffusionForProductQueryParamsSchema = z.object({
      "officeOid": z.string().describe("OID de l'office au nom duquel agir. Pris en compte uniquement pour un utilisateur\nhotline (espace-pro.ROLE_HOTLINE) ; pour tout autre utilisateur, l'office du token\nfait foi et ce paramètre est ignoré. Absent = office de l'utilisateur connecté.\n").optional()
      }).optional()

/**
 * @description Diffusion publiée avec succès.
 */
export const publishDiffusionForProduct200Schema = z.lazy(() => annonceRelanceResponseSchema)

/**
 * @description error occurred - see status code and problem object for more information.
 */
export const publishDiffusionForProduct404Schema = z.object({
      "type": z.string().url().default("about:blank").describe("An absolute URI that identifies the problem type. When dereferenced,\nit SHOULD provide human-readable documentation for the problem type\n(e.g., using HTML).\n"),
  "title": z.string().describe("A short, summary of the problem type. Written in english and readable\nfor engineers (usually not suited for non technical stakeholders and\nnot localized); example: Service Unavailable\n").optional(),
  "status": z.number().int().min(100).max(600).describe("The HTTP status code generated by the origin server for this occurrence\nof the problem.\n").optional(),
  "detail": z.string().describe("A human readable explanation specific to this occurrence of the\nproblem.\n").optional(),
  "instance": z.string().url().describe("An absolute URI that identifies the specific occurrence of the problem.\nIt may or may not yield further information if dereferenced.\n").optional(),
  "properties": z.object({
      
      }).catchall(z.any()).describe("Additional properties that can be used to store any additional information\nabout the problem. This is useful for providing more context or details\nabout the error.\n").optional()
      })

export const publishDiffusionForProductMutationResponseSchema = z.lazy(() => publishDiffusionForProduct200Schema)